import { styled } from "@linaria/react"
import { useRef } from "react"


import { DropdownMenuItemLike } from "@/components/DropdownMenu/DropdownMenu.tsx"
import { Horizontal } from "@/components/Flex.ts"
import { Icon20, UploadLight } from "@/icons/Icons.ts"
import { renameFileIfNeeded, successfulAttachments } from "@/lib/std.ts"

import type { PromptInputModel } from "@/components/PromptInput/PromptInputModel.ts"
import type { RefObject } from "react"

export const AddAttachment = (props: {
  model: PromptInputModel
  setOpen: (open: boolean) => void
}) => {
  const inputFile = useRef<HTMLInputElement | null>(null)

  return (
    <>
      <UploadInput
        type="file"
        ref={inputFile}
        onChange={() => onAddFile(props.model, inputFile.current?.files).then(() => props.setOpen(false))}
        multiple
      />

      <DropdownMenuItemLike onClick={() => onSelectFile(inputFile)}>
        <UploadButtonContainer>
          <UploadLight className={Icon20} />
          Upload from your computer
        </UploadButtonContainer>
      </DropdownMenuItemLike>
    </>
  )
}

function onSelectFile(inputFile: RefObject<HTMLInputElement | null>) {
  inputFile.current?.click()
}

async function onAddFile(model: PromptInputModel, files: FileList | null | undefined) {
  if (!files || !model.onUploadAttachment) return

  const filenames = (await successfulAttachments(model.attachments.get())).map(it => it.filename)

  for (const file of files) {
    const uploadPromise = model.onUploadAttachment(renameFileIfNeeded(file, filenames))
    if (uploadPromise !== null) {
      model.attachments.set([...model.attachments.get(), uploadPromise])
    }
  }
}

const UploadInput = styled.input`
  display: none;
`

const UploadButtonContainer = styled(Horizontal)`
  align-items: center;
  gap: 4px;

  min-height: 28px;

  color: var(--text-color);
  font-size: var(--base-font-size);
`
